import { render, staticRenderFns } from "./LoadFundsAdmin.vue?vue&type=template&id=64a67b5e&"
import script from "./LoadFundsAdmin.vue?vue&type=script&lang=js&"
export * from "./LoadFundsAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports